import { service } from '../../../../helpers/http' 

export const ActionGetCustomerContracts = ({ dispatch }, payload) => { 
    return service({
        module: 'customerContract',
        action: 'getCustomerContracts',
        payload: payload
    })
}

export const ActionGetCustomerContract = ({ dispatch }, payload) => {
    return service({
        module: 'customerContract',
        action: 'getCustomerContract',
        payload: payload,
        unformatResponse: true
    })
}

export const ActionPostCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'postCustomerContracts',
        payload: payload
    })
    
}

export const ActionPutCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'putCustomerContracts',
        payload: payload
    })
    
}

export const ActionDeleteCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'deleteCustomerContracts',
        payload: payload
    })
    
}

export const ActionSimulateCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'simulateCustomerContracts',
        payload: payload
    })

}

export const ActionApproveCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'approveCustomerContracts',
        payload: payload
    })

}

export const ActionCancelCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'cancelCustomerContracts',
        payload: payload
    })

}

export const ActionMarkSentCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'markSentCustomerContracts',
        payload: payload
    })

}

export const ActionMarkApprovedCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'markApprovedCustomerContracts',
        payload: payload
    })

}

export const ActionMarkSignedCustomerContracts = ({ dispatch }, payload) => {

    // Upload de arquivo precisa de multipart (FormData) e o helper nao consegue inferir {id}
    // a partir de FormData; por isso passamos params explicitamente.
    if (payload && payload.id && payload.formData) {
        return service({
            module: 'customerContract',
            action: 'markSignedCustomerContracts',
            params: { id: payload.id },
            payload: payload.formData,
        })
    }

    return service({
        module: 'customerContract',
        action: 'markSignedCustomerContracts',
        payload: payload
    })

}

export const ActionRefuseCustomerContracts = ({ dispatch }, payload) => {

    return service({
        module: 'customerContract',
        action: 'refuseCustomerContracts',
        payload: payload
    })

}
